import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import type { PdfViewer } from '@syncfusion/ej2-pdfviewer';
import { environment } from 'projects/service/src/environments/environment';
import { Companies } from '../../models/app.model';
import { CommonService } from '../../services/common.service';
import { returnOrderTypes, returnOrdersCategoryTypes } from 'projects/service/src/app/modules/home/models/orders.model';
import { loadPdfViewer } from '../../utils/pdf-viewer-loader';

const BASE_URL = environment.apiUrl;

@Component({
    selector: 'app-return-order-statement-viewer',
    templateUrl: './return-order-statement-viewer.component.html',
    styleUrls: ['./return-order-statement-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReturnOrderStatementViewerComponent implements OnInit, OnDestroy {

  private destroyed = false;

  isExpanded: boolean = false;
  showLoader: boolean = false;
  showEmailPopup: boolean = false;

  viewer: PdfViewer;

  @Input() url = '';
  @Input() module = null;
  @Input() returnOrderId: string;
  @Output() onClose = new EventEmitter();
  emailSubject: string;
  employeeName: any;

  constructor(
    private commonService: CommonService
  ) {
    this.employeeName = this.commonService.USER.employeeName;
  }

  ngOnInit(): void {
    if(this.url){
      this.initializeViewer(this.url)
    } else {
      this.commonService.showNotification('error', 'An error occured please try again to see return order statement.')
      this.close();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  async initializeViewer(url: string) {
    const { PdfViewer } = await loadPdfViewer();
    if (this.destroyed) return; // closed while the viewer was downloading
    this.viewer = new PdfViewer();
    this.viewer.enableToolbar = false;
    this.viewer.enablePrint = true;
    this.viewer.printMode  = 'NewWindow';
    this.viewer.enableNavigationToolbar = false;
    this.viewer.hideSaveSignature = true;
    this.viewer.serviceUrl = BASE_URL + 'pdfviewer';
    this.viewer.appendTo('#pdfViewer');
    this.viewer.load(url, null);
}

  onExpandCollapse() {
    this.isExpanded = !this.isExpanded;
    setTimeout(() => {
        if (!this.viewer) return; // still loading
        this.viewer.updateViewerContainer();
        if(this.isExpanded){
            this.viewer.height = '80vh';
        } else {
            this.viewer.height = '55vh';
        }
        this.viewer.updateViewerContainer();
    }, 100);
  }

  print() {
    if (!this.viewer) return; // still loading
    this.viewer.print.print();
    this.viewer.saveAsBlob().then((res: any) => {});
  }

  sendEmail(){
    if(this.module === returnOrderTypes.coreReturnOrder){
      this.emailSubject = `Attachment  - Core Return order ${this.returnOrderId}`;
    } else if (this.module === returnOrderTypes.damagedReturnOrder){
      this.emailSubject = `Attachment  - Damaged Return order ${this.returnOrderId}`;
    } else {
      this.emailSubject = `Return order`;
    }
    this.showEmailPopup = true;
  }

  onEmailPopupClose(){
      this.showEmailPopup = false;
      this.emailSubject = `Return order`;
  }


  close() {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer.formFieldCollection = this.viewer.formFieldCollections = null; // to handle tab key jumping to next input
    }
    Array.from(document.querySelectorAll(`[id^="pdfViewer"]`))
    .forEach((el: HTMLElement) => { el.remove(); });
    this.onClose.emit();
  }
}
